import React from 'react'
import img6 from '../Image/img-6.jpg';

const BranchesContent = () => {
  return (
    <div>
      <div className="container-fuild py-5">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h5 className="section-title ff-secondary text-center text-primary fw-normal">Our Branches</h5>
            <h1 className="pb-5">Most Popular Branches</h1>
          </div>
          <div>
            <div className="row g-1 align-items-center">
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                <div className="row g-2">
                  <div>
                    <img src={img6} />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                <h5 className="section-title ff-secondary text-start text-primary fw-normal">Lorem Ipsum</h5>
                <h2 className="mb-4">Burhanpur</h2>
                <p className="mb-4">Indian sweets or Mithais, an integral part of the Indian cuisine, we at The Taste of Burhanpur bring you irreplaceable delicacies filled with love and care. Get the best of famous sweet Jalebi in differents cities with The Taste of Burhanpur.</p>
                <p className="mb-4">Indian sweets or Mithais, an integral part of the Indian cuisine, we at The Taste of Burhanpur bring you irreplaceable delicacies filled with love and care. Get the best of famous sweet Jalebi in differents cities with The Taste of Burhanpur.</p>

                <p className="mb-4">For the last 38 years, we have been winning the hearts of people with the taste of Jalebi, and will continue to win even further. </p>
                <div className="row g-3 mb-4">

                  <div className="col-sm-7 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="d-flex align-items-center border-start border-5 border-primary px-3">
                      <h1 className="flex-shrink-0 display-5 text-primary mb-0" data-toggle="counter-up">
                        {/* <CountUp duration={3.75} start={1900} end={1984} /> */}
                        {/* <CountUp end={1} duration={3.75}/>
                                <CountUp end={9} duration={3.75}/>
                                <CountUp end={8} duration={3.75}/> */}
                        {/* <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
                                            {
                                                CounterOn && <CountUp start={1900} end={1984} duration={5.75} />
                                            }
                                                
                                        </ScrollTrigger> */}
                      </h1>
                      <div className="ps-3">
                        <p className="mb-0">Year of</p>
                        <h6 className="text-uppercase mb-0">Establishment</h6>
                      </div>
                    </div>
                  </div>


                  <div className="col-sm-5 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="d-flex align-items-center border-start border-5 border-primary px-3">
                      <h1 className="flex-shrink-0 display-5 text-primary mb-0" data-toggle="counter-up">
                        {/* <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
                                            {
                                                CounterOn && <CountUp start={0} end={38} duration={3.55} />
                                            }
                                        </ScrollTrigger> */}

                        {/* <Counter begin={0} end={38} time={2000} easing="outCube" /> */}
                      </h1>
                      <div className="ps-3
                            0">
                        <p className="mb-0">Years of</p>
                        <h6 className="text-uppercase mb-0">Experience</h6>
                      </div>
                    </div>
                  </div>
                </div>
                {/* {
                            location.pathname === '/' && <Link to='/about' className="btn btn-primary py-3 px-5 mt-2 wow fadeInUp " data-wow-delay="0.2s" >Read More</Link>
                        } */}

              </div>
            </div>
          </div>
          {/* <h1 className='text-center'>COMING SOON</h1> */}
          <div>
            <div className="row g-1 align-items-center pt-5">
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                <div className="row g-2">
                  <div>
                    <img src={img6} />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                <h5 className="section-title ff-secondary text-start text-primary fw-normal">Lorem Ipsum</h5>
                <h2 className="mb-4">Burhanpur</h2>
                <p className="mb-4">Indian sweets or Mithais, an integral part of the Indian cuisine, we at The Taste of Burhanpur bring you irreplaceable delicacies filled with love and care. Get the best of famous sweet Jalebi in differents cities with The Taste of Burhanpur.</p>
                <p className="mb-4">Indian sweets or Mithais, an integral part of the Indian cuisine, we at The Taste of Burhanpur bring you irreplaceable delicacies filled with love and care. Get the best of famous sweet Jalebi in differents cities with The Taste of Burhanpur.</p>

                <p className="mb-4">For the last 38 years, we have been winning the hearts of people with the taste of Jalebi, and will continue to win even further. </p>
                <div className="row g-3 mb-4">

                  <div className="col-sm-7 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="d-flex align-items-center border-start border-5 border-primary px-3">
                      <h1 className="flex-shrink-0 display-5 text-primary mb-0" data-toggle="counter-up">
                        {/* <CountUp duration={3.75} start={1900} end={1984} /> */}
                        {/* <CountUp end={1} duration={3.75}/>
                                <CountUp end={9} duration={3.75}/>
                                <CountUp end={8} duration={3.75}/> */}
                        {/* <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
                                            {
                                                CounterOn && <CountUp start={1900} end={1984} duration={5.75} />
                                            }
                                                
                                        </ScrollTrigger> */}
                      </h1>
                      <div className="ps-3">
                        <p className="mb-0">Year of</p>
                        <h6 className="text-uppercase mb-0">Establishment</h6>
                      </div>
                    </div>
                  </div>


                  <div className="col-sm-5 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="d-flex align-items-center border-start border-5 border-primary px-3">
                      <h1 className="flex-shrink-0 display-5 text-primary mb-0" data-toggle="counter-up">
                        {/* <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
                                            {
                                                CounterOn && <CountUp start={0} end={38} duration={3.55} />
                                            }
                                        </ScrollTrigger> */}

                        {/* <Counter begin={0} end={38} time={2000} easing="outCube" /> */}
                      </h1>
                      <div className="ps-3
                            0">
                        <p className="mb-0">Years of</p>
                        <h6 className="text-uppercase mb-0">Experience</h6>
                      </div>
                    </div>
                  </div>
                </div>
                {/* {
                            location.pathname === '/' && <Link to='/about' className="btn btn-primary py-3 px-5 mt-2 wow fadeInUp " data-wow-delay="0.2s" >Read More</Link>
                        } */}

              </div>
            </div>
          </div>
          <div>
            <div className="row g-1 align-items-center pt-5">
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                <div className="row g-2">
                  <div>
                    <img src={img6} />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                <h5 className="section-title ff-secondary text-start text-primary fw-normal">Lorem Ipsum</h5>
                <h2 className="mb-4">Burhanpur</h2>
                <p className="mb-4">Indian sweets or Mithais, an integral part of the Indian cuisine, we at The Taste of Burhanpur bring you irreplaceable delicacies filled with love and care. Get the best of famous sweet Jalebi in differents cities with The Taste of Burhanpur.</p>
                <p className="mb-4">Indian sweets or Mithais, an integral part of the Indian cuisine, we at The Taste of Burhanpur bring you irreplaceable delicacies filled with love and care. Get the best of famous sweet Jalebi in differents cities with The Taste of Burhanpur.</p>

                <p className="mb-4">For the last 38 years, we have been winning the hearts of people with the taste of Jalebi, and will continue to win even further. </p>
                <div className="row g-3 mb-4">

                  <div className="col-sm-7 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="d-flex align-items-center border-start border-5 border-primary px-3">
                      <h1 className="flex-shrink-0 display-5 text-primary mb-0" data-toggle="counter-up">
                        {/* <CountUp duration={3.75} start={1900} end={1984} /> */}
                        {/* <CountUp end={1} duration={3.75}/>
                                <CountUp end={9} duration={3.75}/>
                                <CountUp end={8} duration={3.75}/> */}
                        {/* <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
                                            {
                                                CounterOn && <CountUp start={1900} end={1984} duration={5.75} />
                                            }
                                                
                                        </ScrollTrigger> */}
                      </h1>
                      <div className="ps-3">
                        <p className="mb-0">Year of</p>
                        <h6 className="text-uppercase mb-0">Establishment</h6>
                      </div>
                    </div>
                  </div>


                  <div className="col-sm-5 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="d-flex align-items-center border-start border-5 border-primary px-3">
                      <h1 className="flex-shrink-0 display-5 text-primary mb-0" data-toggle="counter-up">
                        {/* <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
                                            {
                                                CounterOn && <CountUp start={0} end={38} duration={3.55} />
                                            }
                                        </ScrollTrigger> */}

                        {/* <Counter begin={0} end={38} time={2000} easing="outCube" /> */}
                      </h1>
                      <div className="ps-3
                            0">
                        <p className="mb-0">Years of</p>
                        <h6 className="text-uppercase mb-0">Experience</h6>
                      </div>
                    </div>
                  </div>
                </div>
                {/* {
                            location.pathname === '/' && <Link to='/about' className="btn btn-primary py-3 px-5 mt-2 wow fadeInUp " data-wow-delay="0.2s" >Read More</Link>
                        } */}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BranchesContent